export default "__VITE_ASSET__B9TU0hT$__"